import React, { useState } from 'react'
import classnames from 'classnames'
import ActionDropdown from '@SiteComponents/ActionDropdown'
import ArrowDown from '@Images/workspace_row_arrow_down.svg'

import './WorkspaceUserRow.scss'

interface WorkspaceUserRowProps {
  readonly index: number
  readonly userId: number
  readonly name: string
  readonly email: string
  readonly accessType: string
  deleteWorkspaceUser(): void
}

const WorkspaceUserRow: React.FC<WorkspaceUserRowProps> = props => {
  const {
    index,
    name,
    email,
    userId,
    accessType,
  } = props

  const [showDropdown, setShowDropdown] = useState(false)

  const accessElementId = `workspace_user_row_access_${userId}`
  const classNameForClickOutsideListenerAccessDropdown = `WorkspaceUsersTable__action-dropdown-element-${userId}`
  const lastDigitOfUserId = userId % 10
  const hasNoName = name.length === 0
  const nameOrEmailForInitial =  hasNoName ? email : name
  let access = 'Full access'
  if (accessType === 'edit') {
    access = 'Edit access'
  } else if (accessType === 'account_admin') {
    access = 'Admin'
  }

  const unchangeableAccess = accessType === 'account_admin'

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown)
  }

  const actionDropdownList = (
    <ul>
      <li
        className="WorkspaceUsersTable__action-dropdown-item"
        onClick={props.deleteWorkspaceUser}
      >
        <div className="WorkspaceUserRow__action-dropdown-item-text WorkspaceUserRow__action-dropdown-item-text-remove">
          Remove access
        </div>
      </li>
    </ul>
  )

  const renderActionDropdown = () => {
    return (
      <ActionDropdown
        showDropdown={showDropdown}
        dropdownList={actionDropdownList}
        classNamesForListContainer="WorkspaceUsersTable__action-dropdown WorkspaceView__element"
        classNameForClickOutsideListener={classNameForClickOutsideListenerAccessDropdown}
        classNameOfScrollContainer="WorkspaceView"
        idOfDropdownElement={accessElementId}
        idOfPortalContainer="settings"
        dropdownOffsetX={135}
        dropdownOffsetY={5}
        dropdownWidth={255} // same width as WorkspaceUsersTable__action-dropdown
        setShowDropdown={setShowDropdown}
      />
    )
  }

  return (
    <tr
      className={classnames(
        { 'WorkspaceUserRow__even': index % 2 === 0 },
        { 'WorkspaceUserRow__uneven': index % 2 === 1 }
      )}
    >
      <td
        className="WorkspaceUsersTable__workspace-user WorkspaceUserRow__workspace-user"
      >
        <div className={
          `WorkspaceUsersTable__workspace-user-avatar-placeholder WorkspaceUsersTable__workspace-user-avatar-placeholder-background-${9 - lastDigitOfUserId}`
        }>
          {nameOrEmailForInitial.charAt(0)}
        </div>
        <div className="WorkspaceUserRow__workspace-user-name-email">
          <div className="WorkspaceUserRow__workspace-user-name">
            {name}
          </div>
          <div className="WorkspaceUserRow__workspace-user-email">
            {email}
          </div>
        </div>
      </td>
      <td
        className="WorkspaceUsersTable__access WorkspaceUserRow__access"
      >
        {unchangeableAccess ? (
          <div>
            {access}
          </div>
        ) : (
          <div
            className={`WorkspaceUserRow__access-button-wrapper ${classNameForClickOutsideListenerAccessDropdown}`}
            id={accessElementId}
          >
            <div
              className="WorkspaceUserRow__access-button"
              onClick={toggleDropdown}
            >
              <div>
                {access}
              </div>
              <ArrowDown />
            </div>
            {showDropdown && renderActionDropdown()}
          </div>
        )}
      </td>
    </tr>
  )
}

export default WorkspaceUserRow
